(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cat-product-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousel(root) {
      if (root.dataset.cpcInit) return;
      root.dataset.cpcInit = 'true';
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-cpc-tab]'));
      if (!tabs.length) return;

      function activate(tab) {
        tabs.forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        root.querySelectorAll('[data-cpc-panel]').forEach(function (panel) {
          panel.hidden = panel.dataset.cpcPanel !== tab.dataset.cpcTab;
        });
      }

      // Rotacion automatica de tabs (data-cpc-rotate = ms). Se detiene para
      // siempre si el usuario elige un tab manualmente; se pausa con hover,
      // foco, pestana oculta o seccion fuera del viewport. Respeta
      // prefers-reduced-motion.
      var rotateDelay = parseInt(root.dataset.cpcRotate || '0', 10);
      var timer;
      var stopped = false;
      var inView = false;

      function stopRotation() {
        window.clearInterval(timer);
        timer = undefined;
      }

      function startRotation() {
        stopRotation();
        if (stopped || document.hidden || !inView) return;
        timer = window.setInterval(function () {
          var current = 0;
          tabs.forEach(function (t, i) {
            if (t.classList.contains('is-active')) current = i;
          });
          activate(tabs[(current + 1) % tabs.length]);
        }, rotateDelay);
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          stopped = true;
          stopRotation();
          activate(tab);
        });
      });

      if (
        rotateDelay > 0 &&
        tabs.length > 1 &&
        !window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ) {
        root.addEventListener('mouseenter', stopRotation);
        root.addEventListener('mouseleave', startRotation);
        root.addEventListener('focusin', stopRotation);
        root.addEventListener('focusout', startRotation);
        document.addEventListener('visibilitychange', function () {
          if (document.hidden) stopRotation();
          else startRotation();
        });

        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              inView = entry.isIntersecting;
              if (inView) startRotation();
              else stopRotation();
            });
          }, { threshold: 0.35 }).observe(root);
        } else {
          inView = true;
          startRotation();
        }
      }
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('.cat-product-carousel').forEach(initCarousel);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });

    // Al seleccionar un bloque en el Theme Editor, mostrar el tab que lo contiene.
    document.addEventListener('shopify:block:select', function (event) {
      var panel = event.target.closest('[data-cpc-panel]');
      if (!panel) return;
      var root = panel.closest('.cat-product-carousel');
      if (!root) return;
      var tab = root.querySelector('[data-cpc-tab="' + panel.dataset.cpcPanel + '"]');
      if (tab) tab.click();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
